export default function (value, precision) {
  const number = Number.parseFloat(value)
  if (number || number === 0) {
    return number.toFixed(precision)
  }
}
